module.exports = __webpack_public_path__ + "img/EditFeed.ad511487.png";